<template>
  <div class="bar-chart-container">
    <div class="bar-chart">
      <div class="bars">
        <div v-for="(item, index) in data" :key="index" class="bar-container">
          <div
            class="bar"
            :style="{ height: `${item.value}%`, backgroundColor: item.color }"
          >
            <!-- <span class="value">{{ item.value }}</span> -->
          </div>
          <div class="label">{{ item.label }}</div>
        </div>
      </div>
    </div>

    <div class="y-axis">
      <div v-for="(tick, index) in yTicks" :key="index" class="y-tick">
        <span class="y-tick-label">{{ tick }}</span>
        <span class="y-tick-line"></span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, defineExpose } from "vue";

const data = ref([
  { label: "友商a", value: 0, color: "#D9D9D9" },
  { label: "友商b", value: 0, color: "#D9D9D9" },
  { label: "友商c", value: 0, color: "#D9D9D9" },
  { label: "友商d", value: 0, color: "#D9D9D9" },
  { label: "友商e", value: 0, color: "#32A89E" },
]);

const yTicks = ['5000台', '4000台', '3000台', '2000台', '1000台', "yaoke"]; // Y轴刻度值

const animate = () => {
  data.value = [
    { label: "友商a", value: 40, color: "#D9D9D9" },
    { label: "友商b", value: 64, color: "#D9D9D9" },
    { label: "友商c", value: 40, color: "#D9D9D9" },
    { label: "友商d", value: 65, color: "#D9D9D9" },
    { label: "友商e", value: 100, color: "#32A89E" },
  ];
};

defineExpose({
  animate,
});
</script>

<style scoped>
.bar-chart-container {
  display: flex;
  width: 80%;
  margin-left: 20%;
  height: 14.25rem;
  max-width: 30rem;
  font-family: Arial, sans-serif;
  position: relative;
}

.y-axis {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-bottom: 1.5rem; /* 与柱状图底部对齐 */
  box-sizing: border-box;
}

.y-tick {
  display: flex;
  align-items: center;
  position: relative;
  height: 0;
}

.y-tick-label {
  font-size: 0.75rem;
  color: #666;
  text-align: right;
  padding-right: 0.5rem;
}

.y-tick-line {
  flex-grow: 1;
  height: 1px;
  background-color: #eee;
}

.bar-chart {
  flex-grow: 1;
  height: 100%;
  padding-left: 1rem;
  box-sizing: border-box;
}

.bars {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: flex-end;
  justify-content: space-around;
  box-sizing: border-box;
  position: relative;
}

.bar-container {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  width: 2.25rem;
  height: 100%;
}

.bar {
  width: 0.75rem;
  transition: height 1.5s ease-out;
  position: relative;
  border-radius: 0.375rem;
  margin: 0 auto;
}

.value {
  position: absolute;
  top: -1.5rem;
  width: 100%;
  text-align: center;
  font-size: 0.75rem;
  left: 50%;
  transform: translateX(-50%);
}

.label {
  margin-top: 0.625rem;
  font-size: 0.75rem;
  color: #666;
  text-align: center;
}
</style>
